<div class="p-multiselect p-inputwrapper" [ngClass]="{ 'p-focus' : focused }" (click)="onContainerClick($event)">
  <div class="p-multiselect-label-container">
    <div class="p-multiselect-label" [ngClass]="{'p-multiselect-label-empty': selected.length == 0}">
      {{ selected.length > 0 ? (selected | splitMapJoin:'name':', ') : "empty"}}
    </div>
  </div>
  <div class="p-multiselect-trigger">
    <ChevronDownIcon [styleClass]="'p-multiselect-trigger-icon'" [attr.data-pc-section]="'triggericon'" [attr.aria-hidden]="true" />
  </div>
  <p-overlay [(visible)]="showOverlay" [target]="'@parent'" (onHide)="onHide()" [appendTo]="'body'">
     <ng-template pTemplate="content" let-option>
        <div class="p-multiselect-panel p-component">
          <div class="p-multiselect-header">
            <div class="p-multiselect-filter-container">
              <input 
                #idFilterInput
                type="text"
                role="searchbox"
                class="p-multiselect-filter p-inputtext p-component"
                (input)="onFilter($event)"
              />
              <SearchIcon [styleClass]="'p-multiselect-filter-icon'" />
            </div>
          </div>
          <div class="p-multiselect-items-wrapper" style="max-height: 200px;">
            <ul class="p-multiselect-items p-component">
                <li 
                #optionItems
                *ngFor="let option of _options; let i = index" 
                [attr.data-index]="i"
                pRipple 
                [ngClass]="{'p-disabled': option.checked == false && selected.length >= selectionLimit}"
                class="p-multiselect-item"  
                (click)="toggleSelection(option)">
                  <p-checkbox 
                  [ngModel]="option.checked" 
                  [disabled]="option.checked == false && selected.length >= selectionLimit"
                  [binary]="true" 
                  inputId="binary"></p-checkbox>
                  <span>{{option.name}}</span>
                </li>
            </ul>
          </div>
        </div>
    </ng-template>
  </p-overlay>
</div>
